const SIGNATURE_FIELDS = [
  {
    key: 'signed_date',
    name: 'components.lexical.merge_fields.Signed Date',
    placeholder: 'components.lexical.merge_fields.#[Signed Date]'
  }
];

export default SIGNATURE_FIELDS;
